
namespace Matrix.Indexation {
    export class IndexTypeColumns {
        static columnsKey = 'Indexation.IndexType';
    }
}